import {useNavigate, useParams} from "react-router-dom";

import {useDispatch, useSelector} from "react-redux";

import {getWork} from "../../../api/maintenance/WorkService";

import React, {useEffect, useState} from "react";

import {DetailHeroSummaryProvider, DetailTabBar} from "../../../components/detailLayout";

import {CommonHistoryList} from "../../settings/history/subPages/CommonHistoryList";

import {WorkInfo} from "./subPages/WorkInfo";

import {ContentCategory} from "../../../constant/CodeSpecNum";

import {skeleton} from "../../../redux/slice/apiSlice";

import {selectHandlers} from "../../../api/handler/handlerService";

import {changeProgressStatusValue, changeStatusNumericValue} from "../../../redux/slice/contentSlice";

import {getContentStatus} from "../../../api/contentStatus/contentStatusService";

import {WorkPlanReport} from "./subPages/WorkPlanReport";

import {WorkResultReport} from "./subPages/WorkResultReport";



const DEFAULT_TABS = [

    {clicked: true, name: "기본정보"},

    {clicked: false, name: "작업계획서"},

    {clicked: false, name: "작업결과서"},

    {clicked: false, name: "이력관리"},

];



function WorkTab(){

    const { id } = useParams();

    const dispatch = useDispatch();

    const refreshContent = useSelector(state => state.status.refreshContent);

    const statusNumericValue = useSelector(state => state.content.statusNumericValue);



    const [work, setWork] = useState({});

    const [assets, setAssets] = useState([]);

    const [handler, setHandler] = useState([]);

    const [tabs, setTabs] = useState(DEFAULT_TABS);

    const navigate = useNavigate();



    useEffect(() => {

        setWork({});

        setAssets([]);

        setHandler([]);

        setTabs(DEFAULT_TABS);

        dispatch(changeStatusNumericValue(0));

        dispatch(changeProgressStatusValue({}));

    }, [id, dispatch]);



    useEffect(() =>{

        let cancelled = false;



        Promise.all([

            getWork(id),

            selectHandlers({ contentId: id, contentCategory: ContentCategory.WORK}),

            getContentStatus({contentId : id, contentCategory : ContentCategory.WORK})

        ]).then(([workResponse, handlersResponse, statusNumericValueResponse]) => {

            if (cancelled) return;



            if(workResponse.status === 201) {

                if (workResponse.data.errorCode = 'AUTHORITY') {

                    alert(workResponse.data.reason)

                    navigate(-1)

                }

            }



            setWork(workResponse.data);



            if (statusNumericValueResponse && statusNumericValueResponse.status === 200) {

                const numericValue = statusNumericValueResponse.data.statusNumericValue;

                dispatch(changeStatusNumericValue(numericValue));

                dispatch(changeProgressStatusValue(statusNumericValueResponse.data));

            }



            setAssets(workResponse.data.maintenanceAssets?.map(each => each.assets));

            setHandler(handlersResponse.data);

        }).finally(() => {

            if (!cancelled) {

                dispatch(skeleton(false));

            }

        });



        return () => {

            cancelled = true;

        };

    }, [id, dispatch, refreshContent, navigate]);



    if(Object.keys(work).length > 0 && Object.keys(handler).length > 0) {

        return (

            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                <DetailHeroSummaryProvider>
                    <DetailTabBar tabs={tabs} setTabs={setTabs} />

                    {tabs[0].clicked && <WorkInfo id={id} work={work} assets={assets} handler={handler} statusNumericValue={statusNumericValue} />}

                    {tabs[1].clicked && <WorkPlanReport id={id} work={work} assets={assets} handler={handler} statusNumericValue={statusNumericValue} />}

                    {tabs[2].clicked && <WorkResultReport id={id} work={work} assets={assets} handler={handler} statusNumericValue={statusNumericValue} />}

                    {tabs[3].clicked && <CommonHistoryList id={id} tableName={"작업관리"} />}
                </DetailHeroSummaryProvider>
            </div>

        );

    }

}



export {WorkTab}

